import { Loader } from "lucide-react";
import Share from "src/assets/icons-redesign/share.svg?react";
import { ReactElement } from "react";
import { Button } from "src/components/ui/button";
import { Skeleton } from "src/components/ui/skeleton";

type ResultsSidebarHeaderShareProps = {
  variant: "share";
  handleShare: () => void;
  isLoading: boolean;
  shareButtonTitle?: string;
} |
{ variant: "cannotShare"; } |
{ variant: "skeleton"; };

const ResultsSidebarHeaderShare = (props: ResultsSidebarHeaderShareProps): ReactElement | null => {
  const { variant } = props;

  if (variant === "skeleton") {
    return <Skeleton className="size-12" />;
  }

  if (variant === "cannotShare") {
    return null;
  }

  const { handleShare, isLoading, shareButtonTitle } = props;

  return (
    <Button
      title={shareButtonTitle ?? 'Copy a publicly shareable link to this survey’s results'}
      onClick={handleShare}
      variant="primary"
      size="icon"
    >
      {isLoading ? <Loader className="size-10" /> : <Share />}
    </Button>
  );
};

export default ResultsSidebarHeaderShare;
export type { ResultsSidebarHeaderShareProps };
